import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const STORAGE_KEY = 'allone_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          role="dialog"
          aria-label="Çerez bildirimi"
          style={{
            position: 'fixed',
            bottom: '24px',
            left: '24px',
            right: '24px',
            maxWidth: '480px',
            margin: '0 auto',
            zIndex: 9999,
            padding: '18px 20px',
            borderRadius: '16px',
            background: 'rgba(15, 23, 42, 0.95)',
            border: '1px solid rgba(51, 65, 85, 0.4)',
            backdropFilter: 'blur(16px)',
            boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
          }}
        >
          <p style={{ margin: '0 0 14px', color: '#94a3b8', fontSize: '13px', lineHeight: 1.55 }}>
            Oturum ve site deneyimi için çerezler kullanıyoruz.{' '}
            <Link to="/cookies" style={{ color: 'var(--accent-primary)' }}>Çerez Politikası</Link>
          </p>
          <button
            type="button"
            onClick={accept}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '10px',
              border: 'none',
              background: 'var(--gradient-primary)',
              color: 'white',
              fontWeight: 600,
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Kabul et
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
